import React, { ReactElement } from 'react'

export default function TwoLineHeader(): ReactElement {
  return (
    <header>
      <h1>Two Line Header</h1>
    </header>
  )
}
